module.exports = __webpack_public_path__ + "img/logoifdc3.aba99862.png";